/* RESPONSIBLE TEAM: team-workflows */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type IntlService from 'embercom/services/intl';
import { ReactRoute } from 'embercom/lib/react-route';

export default class WorkflowsInspectRoute extends ReactRoute(Route) {
  @service session!: Session;
  @service appService: any;
  @service declare intl: IntlService;
  @service intercomEventService: any;

  analytics = {
    place: 'workflows-inspect',
    section: 'automation',
  };

  get app() {
    return this.appService.app;
  }

  reactEnabled(): boolean {
    return true;
  }

  async beforeModel() {
    this.session.switchWorkspace(this.app.id);
    await this.session.workspace.fetchRequiredAttributes();

    this.intercomEventService.trackEvent('visited-workflows-debugger', {
      onMatchingSystem: true,
    });
  }
}
